import './SearchCanceledPlaceholder.scss';
import classNames, { Argument } from 'classnames';

type SearchCanceledPlaceholderProps = {
  containerClassName?: Argument;
  hint?: JSX.Element | null;
  message?: JSX.Element | string;
};

/**
 * Placeholder to use in the parts of the application where user is able to cancel some search.
 */
function SearchCanceledPlaceholder({ containerClassName = [], hint = null, message = 'Request canceled' }: SearchCanceledPlaceholderProps): JSX.Element {
  return (
    <div className={classNames('SearchCanceledPlaceholder__Container', containerClassName)}>
      <div className="SearchCanceledPlaceholder__Message">{message}</div>
      {hint}
    </div>
  );
}

export default SearchCanceledPlaceholder;
export type { SearchCanceledPlaceholderProps };
